export default __webpack_public_path__ + "static/media/Transfer.ead5a880.svg";